module.exports = __webpack_public_path__ + "img/CreateButton.9d6a02a1.svg";